var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuifang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06_\u4ECA\u65E5\u968F\u8BBF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.69,6.9H19.4a2.08,2.08,0,0,0-1.51.63A2.12,2.12,0,0,0,17.26,9a2.14,2.14,0,0,0,2.14,2.15H47l-9.69,5.63-.89.6a2.12,2.12,0,0,0-1.06,1.8V46.05H19.4a2.14,2.14,0,0,0-1.51,3.66,2.12,2.12,0,0,0,1.51.63H35.33V55a2.14,2.14,0,0,0,2.15,2.14,1.77,1.77,0,0,0,1.06-.35l1.06-.63,0,.05,15.25-9,.88-.6a1.86,1.86,0,0,0,.71-.68l.07-.13a1.68,1.68,0,0,0,.31-1V9a2.16,2.16,0,0,0-1.31-2,2.4,2.4,0,0,0-.84-.15ZM39.52,21l13.1-7.29V43.07l-13.1,7.6V21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.83,19.44a2.12,2.12,0,0,0-1.51.63,2.15,2.15,0,0,0,0,3l3.36,3.36H9.31A2.14,2.14,0,0,0,7.16,28.6a2.12,2.12,0,0,0,.63,1.52,2.16,2.16,0,0,0,1.52.63H21.68l-3.36,3.36a2.15,2.15,0,0,0,0,3,2.1,2.1,0,0,0,1.54.65h0a2.07,2.07,0,0,0,1.49-.63l7.05-7a2.14,2.14,0,0,0,0-3l-7-7a2.16,2.16,0,0,0-1.52-.63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuifang);
export default __webpack_public_path__ + "static/media/suifang.0fc9a334.svg";
export { ForwardRef as ReactComponent };